// ErrorFallback.js

import { Box, Paper, Typography, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import HomeIcon from "@mui/icons-material/Home";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

function ErrorFallback() {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          maxWidth: 600,
          p: 4,
          textAlign: "center",
          borderRadius: 4,
        }}
      >
        <SupportAgentIcon sx={{ fontSize: 60, color: "#00717d", mb: 2 }} />

        <Typography variant="h4" color="error" gutterBottom>
          We’re Sorry for the Inconvenience
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          An unexpected error occurred while processing your request. A support ticket has been
          opened for this issue, and our team is working to resolve it as quickly as possible.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          In the meantime, you can try refreshing the page or return to the homepage. If the problem
          persists, please contact your HR administrator.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#00717d",
              color: "#fff", // make text white
              borderColor: "#00717d", // make border match background
              "&:hover": {
                backgroundColor: "#005f66",
                borderColor: "#005f66",
                color: "#fff",
              },
            }}
            startIcon={<HomeIcon />}
            onClick={() => (window.location.href = "/")}
          >
            Home
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default ErrorFallback;
